export const VERIFICATION_PHRASES: Record<string, number> = {
    VERIFICATION_TITLE: 1507,
    HEADER_ISO_PHYSICIAN: 2788,
    HEADER_NON_ISO_PHYSICIAN: 10829,
    VERIFICATION_IN_PROGRESS: 2137,
    BACK_TO_ACCOUNT: 18818,
} as const;

export const VERIFICATION_DOCUMENTS_PHRASES: Record<string, number> = {
    CANCEL: 189,
    DRAG_AND_DROP: 16537,
    EMPTY_LIST: 16495,
    REMOVE: 1722,
    REMOVE_DIALOG_BODY: 16518,
    REMOVE_DIALOG_TITLE: 16519,
    REMOVE_ERROR: 16503,
    REMOVE_SUCCESS: 2798,
    UPLOAD_ERROR: 16599,
    UPLOAD_SUCCESS: 16598,
    UPLOAD_MORE_THAN_ALLOWED: 16600,
    UPLOAD_NOT_SUPPORTED: 16601,
    TITLE: 16494,
} as const;

export const VERIFICATION_PROFESSIONAL_INFO_PHRASES: Record<string, number> = {
    SUBMIT: 1972,
    TITLE: 16213,
} as const;

export const VERIFICATION_REQUEST_INFO_MESSAGES_PHRASES: Record<string, number> = {
    BOARD_CERTIFIED_OR_ELIGIBILITY: 10640,
    ONLINE_IDENTIFICATION: 18928,
    IDENTITY_VERIFICATION_ONLINE: 19117,
    IDENTIFICATION: 16156,
    LOCATION: 16153,
    MEDICAL_LICENSE_NUMBER: 10641,
    MEDICAL_SCHOOL: 16154,
    PROFESSION: 16155,
    SPECIALTY: 16152,
    NONE: 15661,
} as const;

export const VERIFICATION_ACTION_BOX: Record<string, number> = {
    TITLE: 10648,
    MESSAGE: 1506,
    BUTTON_AUTO_TITLE: 18814,
    BUTTON_MANUAL_TITLE: 18815,
    BUTTON_AUTO_DESCRIPTION: 18816,
    BUTTON_MANUAL_DESCRIPTION: 18817,
} as const;
